import { Endpoints, generateAxios } from '@matap/shared';
import { actionSetUser } from '@/redux';
import { generateMutation } from './create-hooks';
import { actionSetConfigs } from '@/redux/configs.reducer';
import { Platform } from 'react-native';
import { AxiosError } from 'axios';
import { actionLogOut } from '@/redux/general.store';

export const useSignin = generateMutation(Endpoints.auth.user.login, (endpoint) => ({
  mutationFn: (payload) => generateAxios(endpoint, payload).then((r) => r.data),
}));

export const useSendLoginOTP = generateMutation(Endpoints.auth.user.loginOtp, (endpoint, dispatch) => ({
  mutationFn: (payload) =>
    generateAxios(endpoint, payload).then((r) => {
      dispatch(
        actionSetConfigs({
          banners: r.data.banners,
          supportPhoneNumber: r.data.supportPhoneNumber,
          latestVersion: Platform.OS === 'android' ? r.data.android : null,
        }),
      );
      dispatch(actionSetUser(r.data.profile));
      return r.data;
    }),
}));

export const useRenewAuth = generateMutation(Endpoints.auth.user.renew, (endpoint, dispatch) => ({
  mutationFn: (payload) =>
    generateAxios(endpoint, payload)
      .then((r) => {
        dispatch(
          actionSetConfigs({
            banners: r.data.banners,
            supportPhoneNumber: r.data.supportPhoneNumber,
            latestVersion: Platform.OS === 'android' ? r.data.android : null,
          }),
        );
        dispatch(actionSetUser(r.data.profile));
        return r.data;
      })
      .catch((e: AxiosError) => {
        if (e.response?.status === 401) {
          dispatch(actionLogOut());
        }
        throw e;
      }),
}));

export const useLogout = generateMutation(Endpoints.auth.user.logout, (endpoint, dispatch) => ({
  mutationFn: (payload) =>
    generateAxios(endpoint, {}).then(() => {
      dispatch(actionLogOut());
    }),
}));
